<template>
  <b-layout :colors="$site.colors" :header-title="$t('pages.book.detail.title')" :header-back-path="backRoute" :breadcrumbs="breadcrumbs">
    <b-container class="mt-12">
      <b-summary>
        <template #summary>
          <booking-detail :stage="stage" />
        </template>

        <b-card v-if="selectedSlot" :title="$t('pages.book.detail.serviceWithEmployee',{service: service.title, employee: employee.displayName})" class="">
          <div v-if="service.images || service.information" class="flex items-start space-x-4  rtl:space-x-reverse mb-6">
            <div
              v-if="service.images"
              class="h-32 w-32 flex-shrink-0 rounded bg-cover bg-center"
              :style="{ backgroundImage: `url(${service.images.medium})`}"
            />

            <div>
              <p class="text-secondary font-semibold mb-2">
                {{ service.title }}
              </p>
              <p v-if="service.information" class="text-secondary text-sm">
                {{ service.information }}
              </p>
            </div>
          </div>

          <div v-if="employee.images || service.bio" class="flex items-start space-x-4  rtl:space-x-reverse mb-6">
            <div
              v-if="employee.images"
              class="h-32 w-32 flex-shrink-0 rounded bg-cover bg-center"
              :style="{ backgroundImage: `url(${employee.images.medium})`}"
            />

            <div>
              <p class="text-secondary font-semibold mb-2">
                {{ employee.displayName }}
              </p>
              <p v-if="employee.bio" class="text-secondary text-sm">
                {{ employee.bio }}
              </p>
            </div>
          </div>

          <b-button class="w-full mt-4" variant="action" @click="continueSlot">
            {{ $t('general.continue') }} »
          </b-button>
        </b-card>
      </b-summary>
    </b-container>
  </b-layout>
</template>

<script>
definePageMeta({
  tabs: ['online'],
  middleware: ['redirects']
});

import BookingDetail, { BookingStage, createBookingRoute } from '@/components/booking/elements/Detail.vue'

export default defineNuxtComponent({
  components: {
    BookingDetail
  },
  data () {
    return {
      stage: BookingStage.DETAIL,
      selectedSlot: null
    }
  },
  async asyncData () {
    const route = useRoute()
    const bookingStore = useBookingStore()

    await bookingStore.setFromUrlQuery(route.query)

    return {}
  },
  computed: {
    backRoute () {
      const bookingUrlQuery = this.$store.getters['booking/urlQuery']

      return createBookingRoute(bookingUrlQuery, BookingStage.AVAILABILITY)
    },
    breadcrumbs () {
      const bookingUrlQuery = this.$store.getters['booking/urlQuery']

      return [
        { text: this.$site.tabs.getName('book', 'Book'), to: createBookingRoute(bookingUrlQuery, BookingStage.SERVICES) },
        { text: this.$t('pages.book.availability.title'), to: createBookingRoute(bookingUrlQuery, BookingStage.AVAILABILITY) },
        { text: this.$t('pages.book.detail.title'), active: true },
        { text: this.$t('pages.book.confirm.title'), disabled: true }
      ]
    },
    service () {
      return this.selectedSlot?.services[0].service
    },
    employee () {
      return this.selectedSlot?.services[0].employee
    }
  },
  mounted () {
    this.selectedSlot = this.$store.getters['booking/selectedSlot']

    if (!this.selectedSlot) {
      this.$router.push({ path: '/book-now' })
    }
  },
  methods: {
    continueSlot () {
      const bookingUrlQuery = this.$store.getters['booking/urlQuery']

      this.$router.push(createBookingRoute(bookingUrlQuery, BookingStage.CUSTOMER))
    }
  }
})
</script>
